import { useFlags } from 'launchdarkly-react-client-sdk';
import { appRoutes } from '../../../app-routes';
import type { LaunchDarklyFlags } from '../../../types/launch-darkly';
import { NAV_COPY } from '../agents-copy';
import { AgentsNavLinkGroup } from './AgentsNavLinkGroup';
import styles from './AgentsNav.module.css';
import type { AgentsNavGroup, AgentsNavLink } from './agents-nav.types';

const NAV_GROUPS: AgentsNavGroup[] = [
  {
    id: 'start',
    links: [{ label: NAV_COPY.overview, to: appRoutes.AGENTS, matchesExactly: true }],
  },
  {
    id: 'templates',
    heading: 'Templates',
    links: [{ label: 'Voice', to: appRoutes.AGENT_VOICE_TEMPLATE }],
  },
  {
    id: 'components',
    heading: NAV_COPY.componentsHeading,
    links: [
      { label: NAV_COPY.guidance, to: appRoutes.AGENT_GUIDANCE },
      { label: NAV_COPY.skills, to: appRoutes.AGENT_SKILLS },
      { label: 'Escalations', to: appRoutes.AGENT_ESCALATIONS },
    ],
  },
  {
    id: 'building-blocks',
    heading: NAV_COPY.buildingBlocksHeading,
    links: [
      {
        label: NAV_COPY.tools,
        to: appRoutes.AGENT_TOOLS,
        requiresFlag: 'enable-partner-mcp-authoring',
      },
    ],
  },
];

/** The agent builder's own navigation between its overview and component lists. */
export const AgentsNav = () => {
  const flags = useFlags<LaunchDarklyFlags>();
  const linkIsAvailable = (link: AgentsNavLink) =>
    !link.requiresFlag || flags[link.requiresFlag] === true;
  const visibleGroups = NAV_GROUPS.map(group => ({
    ...group,
    links: group.links.filter(linkIsAvailable),
  })).filter(group => group.links.length > 0);

  return (
    <nav className={styles.nav} aria-label={NAV_COPY.navLabel}>
      <h2>{NAV_COPY.title}</h2>
      {visibleGroups.map(group => (
        <AgentsNavLinkGroup key={group.id} group={group} />
      ))}
    </nav>
  );
};
